const getPrefix = () => {
  return '/:lang(en|it)';
};

export default getPrefix;
